<template>
  <section>
    <notifications></notifications>

    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteMany()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push(`/coverage-areas/new`)"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Coverage Area</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 text-right align-self-center"
          >
            <div>
              <div class="box-buttons"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class=""
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="responseArea.pages"
            v-model="currentPage"
            :total="responseArea.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="responseArea.docs"
            :fields="fields"
            sort-by.sync="nameArea"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length == areas.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(nameArea)="data">
              <router-link
                class="capitalize hide-data"
                :to="
                  `/coverage-areas/${data.item._id}?branch=${data.item.branch._id}`
                "
                >{{ data.item.code }}
              </router-link>
            </template>

            <template #cell(description)="data">
              <span class="multiline-3">{{ data.item.description }}</span>
            </template>

            <template #cell(branch)="data">
              <span class="hide-data" v-if="data.item.branch"
                >{{ data.item.branch.name }}
              </span>
            </template>

            <template #cell(country)="data">
              <span class="hide-data" v-if="data.item.branch">{{
                data.item.branch.destination.country.name
              }}</span>
            </template>

            <template #cell(actions)="data">
              <el-tooltip content="Edit" placement="bottom">
                <router-link
                  class="icon-action text-blue"
                  :to="`/coverage-areas/${data.item._id}`"
                >
                  <i class="flaticon-pencil text-primary"></i>
                </router-link>
              </el-tooltip>

              <el-tooltip content="Duplicate" placement="bottom">
                <span
                  class="icon-action ml-2"
                  @click.stop="duplicateAreaService(data.item._id)"
                >
                  <i class="flaticon-copy"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click="deleteAreaService(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="responseArea.pages"
            v-model="currentPage"
            :total="responseArea.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import moment from "moment";
import localHelper from "../Commons/Helper";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";
export default {
  name: "CoverageAreas",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      modal: false,
      branchs: {
        name: ""
      },
      limit: 0,
      searchQuery: "",
      query: "",
      simpleSearch: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "nameArea",
          label: "Area Code",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },
        {
          key: "branch",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "250px" },
          class: "text-left"
        },

        {
          key: "country",
          label: "Country",
          sortable: true,
          thStyle: { minWidth: "250px" },
          class: "text-left"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      view: "table",
      selected: [],
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        { value: "name", text: "Coverage Areas" },
        { value: "branch", text: "Destination" },
        { value: "created_at", text: "Created At" }
      ],
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },

  async created() {
    var bread = [
      {
        text: "Coverage Areas",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.query = this.areasSearchCriterial.query;
    this.currentPage = this.areasSearchCriterial.currentPage;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    applySimpleSearch(value) {
      if (value) {
        this.query = this.addElementInQuery(this.query, "search", value);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.deleteItemInQuery(this.query, ["search"]);
        this.get(true, this.limit, 1, this.query);
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value.trim());
      } else {
        searchParams.append(key, value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    preventPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    async duplicateAreaService(areaId) {
      let { value } = await Swal.fire({
        title: "Duplicate Coverage Areas!",
        text: "Are you sure you want to duplicate this Coverage Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.$router.push({
          path: `/coverage-areas/new`,
          query: { duplicateArea: areaId }
        });
      }
    },
    async deleteAreaService(areaId) {
      let { value } = await Swal.fire({
        title: "Delete Coverage Area",
        text: "Are you sure you want to delete this Coverage Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteAreaById(areaId);
      }
    },
    async deleteAreaById(areaId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.deleteAreaById(
          areaId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Area has been Deleted",
            icon: "flaticon-check-3"
          });
        } else if (data.data.services) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "This Coverage Area Map is assigned to a Rate, please assign another Coverage Area Map for the rate or delete de Coverage Area from the rate parameters",
            icon: "flaticon-remove"
          });
        } else {
          this.setLoad(false);
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Coverage Areas",
        text: "Are you sure do you want to delete the selected Coverage Areas?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyAreas(this.selectedRows);
      }
    },
    async deleteManyAreas(areas = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.deleteManyAreasById(
          { areas: areas },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Areas has been Deleted",
            icon: "flaticon-check-3"
          });
        } else if (data.data.services) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "This Coverage Area Map is assigned to a Rate, please assign another Coverage Area Map for the rate or delete de Coverage Area from the rate parameters",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(areas = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVAreas(
          { areas: areas },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `areas-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async get(loader, limit, page, query) {
      this.setAreasSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getAreas({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "AREAS");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions(["getAreas", "getSearchAreas", "getLimit"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setAreasSearchCriteria"
    ])
  },
  computed: {
    areas: function() {
      if (this.responseArea.docs) {
        return this.responseArea.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "responseArea",
      "sesion",
      "sigout",
      "paginationLimit",
      "areasSearchCriterial"
    ])
  },
  filters: {},
  beforeRouteLeave(to, from, next) {
    localHelper.isInAreasModule(
      to.meta.modules,
      this.setAreasSearchCriteria,
      "areas"
    );

    next();
  }
};
</script>
